





































































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import Datepicker from 'vuejs-datepicker'
import DateClass from '@/app/module/date'
import { ja } from 'vuejs-datepicker/dist/locale'

@Component({
  components: {
    Datepicker
  }
})
export default class CamImageSearch extends Vue {
  private groupSelected: any = [
    { text: 'なし', value: 0 },
    { text: '地区', value: 1 }
  ]
  private grouping: number = this.$store.state.camImageState.grouping
  private recordDate: any = this.$store.state.camImageState.recordDate
  private hasCamera: boolean = this.$store.state.camImageState.hasCamera
  private hasPlanting: boolean = this.$store.state.camImageState.hasPlanting
  private imgSize: string = this.$store.state.camImageState.imgSize
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  @Prop() private isSelectingMode!: boolean

  @Watch('recordDate')
  getChangeRecordDate () {
    this.$store.commit('camImageState/setRecordDate', this.recordDate)
    this.$emit('change-list')
  }

  @Watch('imgSize')
  getChangeImgSize () {
    this.$store.commit('camImageState/setImgSize', this.imgSize)
    this.$emit('change-size')
  }

  @Watch('grouping')
  getChangeGroup () {
    this.$store.commit('camImageState/setGrouping', this.grouping)
    this.$emit('change-group')
  }

  @Watch('hasCamera')
  getChangeHasCamera () {
    this.$store.commit('camImageState/setHasCamera', this.hasCamera)
    this.$emit('change-list')
  }

  @Watch('hasPlanting')
  getChangeHasPlanting () {
    this.$store.commit('camImageState/setHasPlanting', this.hasPlanting)
    this.$emit('change-list')
  }

  private doReset () {
    // 撮影日の初期値は前日
    const date = new Date()
    date.setDate(date.getDate() - 1)
    this.recordDate = date

    this.grouping = 1
    this.hasCamera = true
    this.hasPlanting = false
    this.imgSize = '1'
    this.$store.commit('camImageState/setImgSize', this.imgSize)
    this.$store.commit('camImageState/setGrouping', this.grouping)
    this.$store.commit('camImageState/setHasCamera', this.hasCamera)
    this.$store.commit('camImageState/setHasPlanting', this.hasPlanting)
    this.$store.commit('camImageState/setRecordDate', this.recordDate)
  }

  private nextDate () {
    let newDate = new Date(new Date(this.recordDate).getTime() + 1 * 24 * 60 * 60 * 1000)
    this.recordDate = newDate
  }

  private prevDate () {
    let newDate = new Date(new Date(this.recordDate).getTime() - 1 * 24 * 60 * 60 * 1000)
    this.recordDate = newDate
  }
}
